export default "__VITE_ASSET__CCHDgSrp__"